// src/contexts/produtos/ProdutoSelecaoMultiplosContext.js
import React, { createContext, useContext, useState } from 'react';
import { parseNumeric } from '../../utils/numberUtils';

const ProdutoSelecaoMultiplosContext = createContext(null);

export const ProdutoSelecaoMultiplosProvider = ({ children }) => {
  const [itens, setItens] = useState([]);

  const alterarQuantidade = (produto, incremento) => {
    if (incremento > 0 && parseNumeric(produto?.preco) <= 0) {
      return false;
    }

    setItens(anteriores => {
      const existente = anteriores.find(item => item.produto.id === produto.id);
      const quantidade = Math.max(0, (existente?.quantidade || 0) + incremento);
      if (!quantidade) return anteriores.filter(item => item.produto.id !== produto.id);
      if (!existente) return [...anteriores, { produto, quantidade }];
      return anteriores.map(item => item.produto.id === produto.id ? { ...item, quantidade } : item);
    });

    return true;
  };

  return <ProdutoSelecaoMultiplosContext.Provider value={{
    itens,
    alterarQuantidade,
    unidades: itens.reduce((total, item) => total + item.quantidade, 0),
    subtotal: itens.reduce((total, item) => total + item.quantidade * (parseNumeric(item.produto.preco) || 0), 0),
  }}>{children}</ProdutoSelecaoMultiplosContext.Provider>;
};

export const useProdutoSelecaoMultiplos = () => useContext(ProdutoSelecaoMultiplosContext);
